(ns hai.home.mobile.state
  "UI overlay state for the mobile dashboard — menu drawer, add sheet, toast.
   Lives in its own ns so views (header, drawer, FAB, …) can read it without
   pulling in the rest of the mobile page."
  (:require
   [hai.ui.rf-sugar :refer [defevent defsub]]))

(defevent ::set-menu-open? [db open?]
  ;; Menu drawer and add sheet are mutually exclusive.
  (cond-> (assoc db ::menu-open? open?)
    open? (assoc ::add-sheet-open? false)))

(defevent ::set-add-sheet-open? [db open?]
  (cond-> (assoc db ::add-sheet-open? open?)
    open? (assoc ::menu-open? false)))

(defsub ::menu-open? [db]
  (get db ::menu-open? false))

(defsub ::add-sheet-open? [db]
  (get db ::add-sheet-open? false))
